declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
    __clarityLoaded__?: boolean;
    __PRERENDER__?: boolean;
  }
}

const CLARITY_ID = import.meta.env.VITE_CLARITY_ID;

export const loadClarity = () => {
  if (
    typeof window === 'undefined' ||
    window.__PRERENDER__ ||
    window.__clarityLoaded__ ||
    !CLARITY_ID
  ) {
    return;
  }

  (function (
    c: any,
    l: Document,
    a: string,
    r: string,
    i: string,
    t?: HTMLScriptElement,
    y?: Element,
  ) {
    c[a] =
      c[a] ||
      function (...args: any[]) {
        (c[a].q = c[a].q || []).push(args);
      };
    t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode?.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_ID);

  window.__clarityLoaded__ = true;
};

export const grantClarityConsent = () => {
  if (typeof window === 'undefined' || window.__PRERENDER__) return;

  loadClarity();

  window.clarity?.('consentv2', {
    ad_Storage: 'denied',
    analytics_Storage: 'granted',
  });
};

export const denyClarityConsent = () => {
  if (typeof window === 'undefined' || window.__PRERENDER__) return;

  window.clarity?.('consent', false);

  window.clarity?.('consentv2', {
    ad_Storage: 'denied',
    analytics_Storage: 'denied',
  });
};
